import type { AddressData } from '@adyen/adyen-web'
import type * as Contact from 'types/models/contact.model'
import type * as Brink from 'types/vendors/brink'
import type { ShippingMethod, ShippingMethodName } from '~/types/models/cart.model'
import { isValidEnvironmentCountryCode } from '~/types/guards/storefront'
import { brinkMinorUnits } from '~/data/brink-minor-units'

export function normalizeShippingMethod(shippingMethod: ShippingMethod, currency: string): Brink.DeliveryMethod {
  const shippingMethodDisplayName = shippingMethod.title ? `${shippingMethod.title} - ${shippingMethod.deliveryDetails} ${shippingMethod.price === 0 ? ' (Free)' : ''}` : shippingMethod.deliveryDetails
  return {
    reference: shippingMethod.id,
    description: shippingMethodDisplayName,
    amount: {
      currency,
      value: Math.round(shippingMethod.price * 10**brinkMinorUnits[currency]),
    },
  }
}

export function convertShippingMethod(shippingMethod: Adyen.PayPalShippingMethodSelection): ShippingMethod {
  return {
    title: shippingMethod.id,
    deliveryDetails: shippingMethod.label,
    price: Number(shippingMethod.amount.value),
    id: shippingMethod.id as ShippingMethodName,
    available: true,
    discountAmount: 0,
  }
}

export function normalizeAddress(data: { authorizedEvent: any, address: AddressData }, isShipping?: boolean): { address: Contact.Address, information: Contact.Information } {
  const payer = data.authorizedEvent.payer
  const storefrontStore = useStorefrontStore()
  const { countryCode } = storefrontStore.currentMarket
  const address = data.address

  const addressCountryCode = address.country ? isValidEnvironmentCountryCode(address.country) ? address.country : countryCode : countryCode

  const lastName = isShipping ? address.lastName : address.lastName || payer.name.surname
  return {
    address: {
      country: addressCountryCode,
      city: address.city || '',
      street0: address.street || '',
      street1: address.houseNumberOrName || '',
      lastName: lastName || '',
      firstName: address.firstName || payer.name.given_name || '',
      postCode: address.postalCode || '',
      region: address.stateOrProvince || '',
    },
    information: {
      telephone: payer.phone.phone_number.national_number || '',
      email: payer.email_address || '',
      agreements: true,
      newsletterSubscription: false,
    },

  }
}
